var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"6","fill":"none"}},[_c('path',{attrs:{"fill":"currentcolor","d":"M6 5.588.804.431h10.392L6 5.588Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }